<template>
  <div class="mx-2 mb-2">
    <b-row>

      <b-col
        cols="12"
        sm="6"
        class="d-flex align-items-center justify-content-center justify-content-sm-start"
      >
        <span class="text-muted">{{ $t('Showing') }} {{ from }} {{ $t('to') }} {{ to }} {{ $t('of') }} {{ totalRows }} {{ $t('entries') }} </span>
      </b-col>

      <!-- Pagination -->
      <b-col
        cols="12"
        sm="6"
        class="d-flex align-items-center justify-content-center justify-content-sm-end"
      >
        <Pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
        />
      </b-col>

    </b-row>
  </div>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'

import Pagination from '@/views/components/pagination/Pagination.vue'

export default {
  name: 'TablePagination',
  components: {
    BRow,
    BCol,
    Pagination,
  },
  props: {
    from: {
      type: Number,
      required: true,
    },
    to: {
      type: Number,
      required: true,
    },
    perPage: {
      type: Number,
      required: true,
    },
    totalRows: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      currentPage: 1,
    }
  },
  computed: {
    hasValue() {
      return !!this.currentPage
    },
  },
  watch: {
    currentPage(value) {
      this.$emit('input', value)
    },
  },
  created() {
    if (this.value) {
      this.currentPage = this.value
    }
  },
}
</script>
